import * as dateFns from 'date-fns'
export const fns = dateFns

export const convertTimeStampForHuman = (timestamp, format = 'yyyy-MMM-dd HH:mm a') => {
	if (timestamp instanceof Date) { timestamp = timestamp.toISOString() }
	return dateFns.format(new Date(timestamp), format)
}

export const convertTimeLocalStamp = (timestamp, format = 'yyyy-MMM-dd h:mm a') => {
	const isoDate = timestamp.replace(' ', 'T') + 'Z';
	const date = new Date(isoDate);
	return date.toLocaleString('en-AU', {
		year: 'numeric',
		month: 'long',
		day: '2-digit',
		hour: 'numeric',
		minute: '2-digit',
		hour12: true
	});
}

export const convertTimeStampToDate = (timestamp, format = 'yyyy MMM dd') => {
	if (timestamp instanceof Date) { timestamp = timestamp.toISOString() }
	return dateFns.format(new Date(timestamp), format)
}

export const resetToTheHour = (date) => {
	if (!date instanceof Date) { return }
	let reset = dateFns.setMinutes(dateFns.setSeconds(dateFns.setMilliseconds(date, 0), 0), 0)
	return reset
}

export const differenceInDays = (end, start) => {
	end = dateFns.startOfDay(new Date(dateFns.parseJSON(end)));
	start = dateFns.startOfDay(new Date(dateFns.parseJSON(start)));
	let difference = dateFns.differenceInDays(end, start);
	return difference;
}

export const differenceInHours = (end, start) => {
	end = dateFns.startOfDay(new Date(dateFns.parseJSON(end)));
	start = dateFns.startOfDay(new Date(dateFns.parseJSON(start)));
	let difference = dateFns.differenceInHours(end, start);
	return difference;
}

export const differenceInBusinessDays = (end, start) => {
	end = dateFns.startOfDay(new Date(dateFns.parseJSON(end)));
	start = dateFns.startOfDay(new Date(dateFns.parseJSON(start)));
	let difference = dateFns.differenceInBusinessDays(end, start);
	return difference;
}

export const differenceInMinutes = (end, start) => {
	end = new Date(dateFns.parseJSON(end));
	start = new Date(dateFns.parseJSON(start));
	let difference = dateFns.differenceInMinutes(end, start);
	return difference;
}

export const daysInBetween = (end, start) => {
	end = dateFns.parseJSON(end);
	start = dateFns.parseJSON(start);
	let difference = dateFns.differenceInDays(end, start);
	let days = [];
	for (let i = 0; i < difference; i++) {
		days.push(dateFns.format(dateFns.addDays(start, i), 'd MMM'));
	}
	return days;
}

export const hoursInBetween = (end, start) => {
	end = dateFns.parseJSON(end);
	start = dateFns.parseJSON(start);
	let difference = dateFns.differenceInHours(end, start);
	let days = [];
	for (let i = 0; i < difference; i++) {
		days.push(dateFns.format(dateFns.addHours(start, i), 'd MMM h aaa'));
	}
	return days;
}
export const minutesInBetween = (end, start) => {
	end = dateFns.parseJSON(end);
	start = dateFns.parseJSON(start);
	let difference = dateFns.differenceInMinutes(end, start);
	let minutes = [];
	for (let i = 0; i < difference; i++) {
		minutes.push(dateFns.format(dateFns.addMinutes(start, i), 'h:mm aaa'));
	}
	return minutes;
}

export const addDays = (date, days) => {
	if (!date instanceof Date) { return }
	date = dateFns.parseJSON(date);
	return dateFns.addDays(date, days);
}

export const addHours = (date, hours) => {
	if (!date instanceof Date) { return }
	date = dateFns.parseJSON(date);
	return dateFns.addHours(date, hours);
}

export const getDate = (date) => {
	if (!date instanceof Date) { return }
	date = dateFns.parseJSON(date);
	return dateFns.format(date, 'dd-MM-yy');
}

export const getHour = (date) => {
	if (!date instanceof Date) { return }
	date = dateFns.parseJSON(date);
	return dateFns.format(date, 'dd-MM-yy h aaa');
}

export const addTime = (date, amount, type = 'minutes') => {
	if (!date instanceof Date) { return }
	let method = type.charAt(0).toUpperCase() + type.slice(1);
	return dateFns[`add${method}`](date, amount);
}

export const stripSeconds = (date) => {
	if (!date instanceof Date) { return }
	return dateFns.setMilliseconds(
		dateFns.setSeconds(date, 0)
		, 0);

}

export const stripMinutesAndSeconds = (date) => {
	if (!date instanceof Date) { return }
	return dateFns.setMinutes(
		stripSeconds(date)
		, 0);
}

export const stripHoursMinutesAndSeconds = (date) => {
	if (!date instanceof Date) { return }
	return dateFns.setHours(
		stripMinutesAndSeconds(date)
		, 0);
}

export const stripDaysHoursMinutesAndSeconds = (date) => {
	if (!date instanceof Date) { return }
	return dateFns.setDate(
		stripHoursMinutesAndSeconds(date)
		, 0);
}

export const compareDates = (firstDate, secondDate, precision = 'minutes') => {
	switch (precision) {
		case 'months':
			return dateFns.isEqual(stripDaysHoursMinutesAndSeconds(firstDate), stripDaysHoursMinutesAndSeconds(secondDate))
			break;
		case 'days':
			return dateFns.isEqual(stripHoursMinutesAndSeconds(firstDate), stripHoursMinutesAndSeconds(secondDate))
			break;
		case 'hours':
			return dateFns.isEqual(stripMinutesAndSeconds(firstDate), stripMinutesAndSeconds(secondDate))
			break;
		case 'minutes':
		default:
			return dateFns.isEqual(stripSeconds(firstDate), stripSeconds(secondDate))
			break;
	}
}
